// extracted by css-extract-rspack-plugin
export default {"loadMoreWrapper":"IssueTimeline-module__loadMoreWrapper__H_hm5Cz"};